import { systemProduction } from '../solar/selectors';


export const getSMARTvalue = (state) => {
    const { smartValue } = state.smart;
    const { systemSize } = state.solar;
    const { projectState } = state.projectaddress;
    const systemProd = systemProduction(state);


    const results = {};

    let smartYears = 10;
    if (systemSize / 1000 > 25) {
        smartYears = 20;
    }


    for (let year = 1; year <= 30; year += 1) {
        let annualSMARTVal = 0;

        if (year <= smartYears && projectState === 2) {
            annualSMARTVal = systemProd[year] * smartValue;
        } else {
            annualSMARTVal = 0;
        }

        results[year] = annualSMARTVal;
    }
    return results;
};

export default getSMARTvalue;


export const getMAStateTaxCredit = (state, year) => {
    const { resiToggle } = state.tax;
    const { projectState } = state.projectaddress;

    let credit = 0;
    if (resiToggle && projectState === 2 && year === 1) {
        credit = 1000;
    }


    return credit;
};



// WEBPACK FOOTER //
// ./src/containers/common/smart/selectors.js